import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import SignupForm from "@/components/SignupForm";

const CrearCuenta = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <div className="mx-auto max-w-lg rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <SignupForm
            allowSearchUser
            onSuccess={() => setTimeout(() => navigate("/iniciar-sesion"), 2500)}
          />
        </div>
      </main>
    </>
  );
};

export default CrearCuenta;
